module.exports = __webpack_public_path__ + "img/pic05@2x.e0e02aa5.png";